import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../components/layout/Loading";
import { getFindByIDBookingHotelVoucher } from "../fitbooking/services/FITBooking.services";
import { checkAcessRights } from "../../_helper/helper";
import { PDF_DOWNLOAD_ACCESS, PRINT_ACCESS } from "../../_contstants/common";
import { Button } from "@progress/kendo-react-buttons";
import { API_URL } from "../../app/config";
import { ErrorToast } from "../../components/toast/Toasts";

const HotelVoucherView = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const params = useParams();
  const AccomodationID = params?.AccomodationID;
  const PackageBooking_GUID = params?.PackageBooking_GUID;

  const FITBookingHotelVoucherDetail = useAppSelector(
    (state) => state.FITBooking.FITBookingHotelVoucherDetail
  );
  const loading = useAppSelector((state) => state.FITBooking.loading);

  const isPrintAccess = checkAcessRights("/hotelvoucher", PRINT_ACCESS);
  const isPDFDownloadAccess = checkAcessRights(
    "/hotelvoucher",
    PDF_DOWNLOAD_ACCESS
  );

  const [downloadLoading, setDownloadLoading] = useState(false);

  useEffect(() => {
    if (AccomodationID && PackageBooking_GUID) {
      const payload = {
        PackageBooking_GUID: PackageBooking_GUID ? PackageBooking_GUID : "",
        AccomodationID: AccomodationID ? +AccomodationID : null,
      };
      dispatch(getFindByIDBookingHotelVoucher(payload));
    }
  }, [AccomodationID, PackageBooking_GUID]);

  const handleDownloadInvoice = async () => {
    const payload = {
      PackageBooking_GUID: PackageBooking_GUID ? PackageBooking_GUID : "",
      AccomodationID: AccomodationID ? +AccomodationID : null,
    };
    setDownloadLoading(true);
    try {
      const response = await fetch(
        `${API_URL}/PackageBooking/BookingHotelVoucherDownload`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
          body: JSON.stringify(payload),
        }
      );
      if (!response.ok) {
        ErrorToast("Failed to generate PDF! - Please try after some time");
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `${FITBookingHotelVoucherDetail?.FirstName} ${FITBookingHotelVoucherDetail?.LastName} - Hotel Voucher.pdf`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to download! - Please try again later");
    } finally {
      setDownloadLoading(false);
    }
  };

  return (
    <>
      {(loading || downloadLoading) && <LoadingPanel gridRef={gridRef} />}
      <div className="no-visible-print-btn text-center mt-3">
        {isPrintAccess && (
          <Button
            type="button"
            style={{
              marginRight: 10,
              width: 100,
            }}
            fillMode={"solid"}
            themeColor={"primary"}
            onClick={() => window.print()}
          >
            Print
          </Button>
        )}
        {isPDFDownloadAccess && (
          <Button
            type="button"
            fillMode={"solid"}
            themeColor={"primary"}
            onClick={handleDownloadInvoice}
            style={{ marginRight: 5, width: 100 }}
          >
            Download
          </Button>
        )}
      </div>
      <div className="quotation-container">
        <div className="row">
          <div className="col-2 d-flex align-items-center">
            <img
              src={FITBookingHotelVoucherDetail?.CompanyDetails?.CompanyLogo}
              alt=""
              width="100%"
            />
          </div>
          <div className="col-7" style={{ borderLeft: "1px solid black" }}>
            <h5 className="fw-600">
              {FITBookingHotelVoucherDetail?.CompanyDetails?.CompanyName}
            </h5>
            <div className="d-flex" style={{ gap: 100 }}>
              <span>
                <span className="fw-600">GST : </span>{" "}
                {FITBookingHotelVoucherDetail?.CompanyDetails?.GSTNo}
              </span>
            </div>
            <div className="d-flex" style={{ gap: 100 }}>
              <span>
                <span className="fw-600">PAN : </span>{" "}
                {FITBookingHotelVoucherDetail?.CompanyDetails?.PANNo}
              </span>
            </div>
            <div className="d-flex" style={{ gap: 100 }}>
              <span>
                <span className="fw-600">Mobile : </span>{" "}
                {FITBookingHotelVoucherDetail?.CompanyDetails?.MobileNo}
              </span>
            </div>
            <div>
              <span className="fw-600">Email : </span>{" "}
              {FITBookingHotelVoucherDetail?.CompanyDetails?.EmailID}
            </div>
          </div>
          <div
            className="col-3"
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {FITBookingHotelVoucherDetail?.CompanyDetails?.Address} <br />
            {FITBookingHotelVoucherDetail?.CompanyDetails?.CityName}{" "}
            {FITBookingHotelVoucherDetail?.CompanyDetails?.Pincode
              ? `- ${FITBookingHotelVoucherDetail?.CompanyDetails?.Pincode}`
              : ""}{" "}
            <br />
            {FITBookingHotelVoucherDetail?.CompanyDetails?.StateName
              ? `State: ${FITBookingHotelVoucherDetail?.CompanyDetails?.StateName}`
              : ""}{" "}
            <br />
            {FITBookingHotelVoucherDetail?.CompanyDetails?.CountryName
              ? `Country: ${FITBookingHotelVoucherDetail?.CompanyDetails?.CountryName}`
              : ""}
          </div>
        </div>
        <div className="section-title main-title">
          Hotel Confirmation Voucher
        </div>
        <div className="section">
          <div className="info d-flex justify-content-between">
            <div>
              <span className="info-label">Tour Booking No. :</span>{" "}
              <span className="highlight section-title border-0">
                {FITBookingHotelVoucherDetail?.TourBookingNo}
              </span>
            </div>
            <div>
              <span className="info-label">Date :</span>{" "}
              <span className="highlight">
                {FITBookingHotelVoucherDetail?.BookingDate}
              </span>
            </div>
          </div>
        </div>

        <div className="section-title">Guest Details</div>
        <div className="section">
          <table className="data-table">
            <tr>
              <td colSpan={2}>
                <span className="fw-bold">Name :</span>{" "}
                {FITBookingHotelVoucherDetail?.FirstName}{" "}
                {FITBookingHotelVoucherDetail?.LastName}
              </td>
              <td colSpan={2}>
                <span className="fw-bold">Mobile No. :</span>{" "}
                {FITBookingHotelVoucherDetail?.MobileNo}
              </td>
            </tr>
            <tr>
              <td style={{ width: "25%" }}>
                <span className="fw-bold">Adult :</span>{" "}
                {FITBookingHotelVoucherDetail?.TotalAdult}
              </td>
              <td style={{ width: "25%" }}>
                <span className="fw-bold">Child :</span>{" "}
                {FITBookingHotelVoucherDetail?.TotalCWB}
              </td>
              <td style={{ width: "25%" }}>
                <span className="fw-bold">Infant :</span>{" "}
                {FITBookingHotelVoucherDetail?.TotalCNB}
              </td>
              <td style={{ width: "25%" }}>
                <span className="fw-bold">Total Pax :</span>{" "}
                {FITBookingHotelVoucherDetail?.TotalPax}
              </td>
            </tr>
            <tr>
              <td>
                <span className="fw-bold">Total Room :</span>{" "}
                {FITBookingHotelVoucherDetail?.TotalRoom}
              </td>
              <td>
                <span className="fw-bold">Room Type :</span>{" "}
                {FITBookingHotelVoucherDetail?.RoomType}
              </td>
              <td>
                <span className="fw-bold">Meal Plan :</span>{" "}
                {FITBookingHotelVoucherDetail?.MealType}
              </td>
              <td></td>
            </tr>
          </table>
        </div>
        <div className="section-title">Hotel Details</div>
        <div className="section">
          <table className="data-table">
            <tr>
              <td colSpan={2}>
                <span className="fw-bold">Hotel Name :</span>{" "}
                {FITBookingHotelVoucherDetail?.HotelName}
              </td>
              <td>
                <span className="fw-bold">Phone No. :</span>{" "}
                {FITBookingHotelVoucherDetail?.PhoneNo}
              </td>
            </tr>
            <tr>
              <td colSpan={3}>
                <span className="fw-bold">Address :</span>{" "}
                {FITBookingHotelVoucherDetail?.Address}
              </td>
            </tr>
            <tr>
              <td style={{ width: "33.33%" }}>
                <span className="fw-bold">Check In Date :</span>{" "}
                {FITBookingHotelVoucherDetail?.CheckInDate}
              </td>
              <td style={{ width: "33.33%" }}>
                <span className="fw-bold">No.Of Nights :</span>{" "}
                {FITBookingHotelVoucherDetail?.NoofNights}
              </td>
              <td style={{ width: "33.33%" }}>
                <span className="fw-bold">Check Out Date :</span>{" "}
                {FITBookingHotelVoucherDetail?.CheckOutDate}
              </td>
            </tr>
          </table>
        </div>
        <div className="section-title">Meal Plan Bifurcation</div>
        <div className="section tnc-section">
          <ul className="d-flex flex-column">
            <li>
              <span className="text-dark">EP</span> : Only stay
            </li>
            <li>
              <span className="text-dark">CP</span> : Stay + Breakfast
            </li>
            <li>
              <span className="text-dark">AP</span> : Breakfast + Lunch + Dinner
            </li>
            <li>
              <span className="text-dark">MAP</span> : Breakfast + One major
              meal
            </li>
          </ul>
        </div>

        <div className="section-title">Terms & Conditions</div>
        <div className="tnc-section">
          <ul className="ps-4">
            <li>All disputes are subject to jurisdiction of Ahmedabad only.</li>
            <li>
              The check-in time is 14:00 hrs and check-out time is 11:00 am.
            </li>
            <li>
              This voucher is issued irrevocable for the period specified and
              the client is responsible for late arrival &amp; early departure.
            </li>
            <li>
              {FITBookingHotelVoucherDetail?.CompanyDetails?.CompanyName} only
              acts as an agent of the hotel concerned and bears no
              responsibility.
            </li>
            <li>
              {FITBookingHotelVoucherDetail?.CompanyDetails?.CompanyName} is not
              responsible for any illness, loss, damage, theft, injury, death
              etc. suffered by the client.
            </li>
            <li>
              All prevalent rules &amp; regulations of hotel / resort are
              binding. Booking once confirmed cannot be cancelled.
            </li>
          </ul>
        </div>
        <div className="section-title">Cancellation / Refund</div>
        <div className="tnc-section">
          <ul className="ps-4">
            <li>
              All cancellations / amendments will be applicable as per the hotel
              rules.
            </li>
            <li>
              As per government rules, photo ID required – any government-issued
              photo ID like passport, driving license, PAN card etc.
            </li>
            <li>
              No refund would be made for any reason whatsoever unless we have
              stamped original voucher signed by the hotel clearly stating that
              refunds should be made.
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default HotelVoucherView;
